// extracted by mini-css-extract-plugin
export default {"modalOverlay":"MI-z","modalContent":"NI-z","header":"OI-z","close":"PI-z"};